export type ConversionContext = {
  sessionId: string;
  landingPage: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
};

const SESSION_KEY = "eq_sid";
const CONTEXT_KEY = "eq_conversion_context";

export function getSessionId(): string {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

/** Mantém a primeira página e as UTMs da visita durante toda a sessão. */
export function getConversionContext(): ConversionContext {
  const stored = sessionStorage.getItem(CONTEXT_KEY);
  if (stored) {
    try {
      return JSON.parse(stored) as ConversionContext;
    } catch {
      sessionStorage.removeItem(CONTEXT_KEY);
    }
  }
  const params = new URLSearchParams(window.location.search);
  const context: ConversionContext = {
    sessionId: getSessionId(),
    landingPage: `${window.location.pathname}${window.location.search}`.slice(0, 500),
    utmSource: params.get("utm_source")?.slice(0, 191) || undefined,
    utmMedium: params.get("utm_medium")?.slice(0, 191) || undefined,
    utmCampaign: params.get("utm_campaign")?.slice(0, 191) || undefined,
  };
  sessionStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
  return context;
}

/** Página efetiva da conversão, preservada separadamente da primeira entrada da sessão. */
export function getCurrentConversionPage(): string {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}`.slice(0, 500);
}
